import { Vue, Options } from 'vue-class-component';
import { SET_APP_LOADING } from '@/core/store/action-types';
import {
  EPDeviceDTO,
  EpDeviceType,
  EntrancePlantDetailDTO,
  GraylogEntrancePanelMessageDTO,
} from '@/../client-generator/generated-clients/plants';
import ListItemCheck from '@/views/components/ListItemCheck/ListItemCheck.vue';
import { mapState } from 'vuex';
import plantsClient from '@/core/services/plants';

@Options({
  name: 'DialogReportEpIssue',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible(newValue) {
      this.isDialogVisible = newValue;
      this.theMessage = '';
      this.step = 0;
      this.selectedDevices = [];
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: { ListItemCheck },
  emits: ['hide-dialog'],
})
export default class DialogReportEpIssue extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  isVisible!: boolean;
  isDialogVisible = false;
  theMessage = '';
  selectedDevice: EPDeviceDTO | null = null;
  step = 0;

  get primaryButtonDisabled() {
    return !this.selectedDevice;
  }

  get plantDevices() {
    if (this.currentEntrancePlant.gates === undefined) return [];
    const EPDeviceListConnected: {
      device: EPDeviceDTO;
      gate: string | undefined;
    }[] = [];
    this.currentEntrancePlant.gates?.forEach((gate) =>
      gate.devices?.forEach((device) => {
        if (device.type === EpDeviceType.Linea5000 && device.configNetwork?.isConnectedToEliot) {
          EPDeviceListConnected.push({
            device: device,
            gate: gate.name,
          });
        }
      })
    );
    return EPDeviceListConnected;
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  handleSecondaryButton() {
    this.step === 0 ? this.handleHideDialog() : this.step--;
  }

  handlePrimaryButton() {
    this.step === 0 ? this.step++ : this.sendMessage();
  }

  async sendMessage() {
    this.isDialogVisible = false;
    if (this.currentEntrancePlant.desktopId === undefined) return;

    this.$store.dispatch(SET_APP_LOADING, true);

    try {
      const graylogMessage = new GraylogEntrancePanelMessageDTO({
        frontendVersion: this.$config.FRONTEND_VERSION,
        deviceId: this.selectedDevice?.deviceId,
        userMessage: this.theMessage,
        plantDesktopId: this.currentEntrancePlant.desktopId,
      });

      const logsSent = await plantsClient.sendlogs(graylogMessage);
      if (logsSent) {
        this.$toast.add({
          severity: 'success',
          summary: this.$t('AppResourceEP.ProblemReported'),
          closable: false,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 4000,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
